import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { AyvensQuestion } from './AyvensQuestion';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EVENT = 'ayvens-questionario-required';
const CODE = 'AYVENS_QUESTIONARIO_RICHIESTO';

const parseDetail = async (data) => {
  try {
    const json = data instanceof Blob ? JSON.parse(await data.text()) : data;
    return json?.detail?.code === CODE ? json.detail : null;
  } catch {
    return null;
  }
};

// Intercetta i 428 del backend (questionario mancante) ovunque nell'app
axios.interceptors.response.use(undefined, async (error) => {
  if (error?.response?.status === 428) {
    const detail = await parseDetail(error.response.data);
    if (detail) {
      error.ayvensHandled = true;
      window.dispatchEvent(new CustomEvent(EVENT, { detail }));
    }
  }
  return Promise.reject(error);
});

export const AyvensQuestionnaireDialog = () => {
  const { getAuthHeader } = useAuth();
  const [pending, setPending] = useState(null);
  const [answer, setAnswer] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const handler = (e) => { setPending(e.detail); setAnswer(null); };
    window.addEventListener(EVENT, handler);
    return () => window.removeEventListener(EVENT, handler);
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/contacts/${pending.contact_id}/ayvens-questionario`,
        { gia_cliente_ayvens: answer }, { headers: getAuthHeader() });
      toast.success(answer
        ? 'Risposta salvata: il PDF uscirà senza dati anagrafici fino alla verifica della Sede'
        : 'Risposta salvata: ora puoi ristampare il PDF');
      setPending(null);
      window.dispatchEvent(new CustomEvent('ayvens-questionario-saved'));
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Errore nel salvataggio');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!pending} onOpenChange={(o) => !o && setPending(null)}>
      <DialogContent className="sm:max-w-md" data-testid="ayvens-questionnaire-dialog">
        <DialogHeader>
          <DialogTitle>Integrazione obbligatoria</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-600">
          Per <strong>{pending?.nome_cognome || 'questo cliente'}</strong> manca la risposta al questionario d'ingresso.
          Compilalo per proseguire con la stampa dell'offerta.
        </p>
        <AyvensQuestion value={answer} onChange={setAnswer} variant="staff" testIdPrefix="ayvens-dialog" />
        <div className="flex gap-2 justify-end">
          <Button variant="outline" onClick={() => setPending(null)} data-testid="ayvens-dialog-cancel">Annulla</Button>
          <Button onClick={save} disabled={answer === null || saving} data-testid="ayvens-dialog-save">Salva risposta</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
